/** Each application's accent colour (the names an admin picks under Applications), for the rail, chooser and header. */
const APP_COLOURS: Record<string, string> = {
  indigo: '#4338ca',
  teal: '#0f766e',
  blue: '#1d4ed8',
  green: '#15803d',
  amber: '#b45309',
  rose: '#be123c',
  purple: '#7e22ce',
  slate: '#475569',
};

/** The colour of the shared Organisation workspace. */
export const ORG_COLOUR = APP_COLOURS['slate'];

/** The hex colour for an application's colour name, indigo when it has none or an unknown one. */
export function appColour(name: string | null | undefined): string {
  return APP_COLOURS[name ?? ''] ?? APP_COLOURS['indigo'];
}
